import { alertDefaultOptions } from '../constants/options';
import { ModalOption, ModalPromiseResult } from '../../interface/IModal';
import Popup from './Popup';

export default class Toast extends Popup {
    constructor() {
        super();
    }
    async open(options: ModalOption): Promise<ModalPromiseResult> {
        return super.open({ ...alertDefaultOptions, ...options });
    }
}
